export default __webpack_public_path__ + "static/international-yards-mobile-29562cef419e3ca9402d831fe11c17ba.svg";